/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-30 09:33:00
 * @LastEditors: dengyao
 * @LastEditTime: 2024-07-25 17:35:23
 */
import { defineStore } from 'pinia'
import { LoginRes } from '@/service/model'
import { ajaxAuthService } from '@/service/api/index'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: '',
    userInfo: {} as LoginRes,
    userLevel: '',
    isLoggedIn: false,
    menuList: [
      {
        name: '首页',
        icon: 'index',
        id: 1,
        path: '/dataDashboard'
      },
      {
        name: '快件跟踪',
        icon: 'expressTracking',
        id: 2,
        path: '/expressTracking'
      },
      {
        name: '订单录入',
        icon: 'orderEntry',
        id: 3,
        path: '/orderEntry'
      },
      {
        name: '订单列表',
        icon: 'orderList',
        id: 4,
        path: '/orderList'
      },
      {
        name: '资金管理',
        icon: 'orderList',
        id: 5,
        childs: [
          {
            name: '寄件提成报表',
            id: 51,
            parentId: 5,
            path: '/sendCommissionReport'
          },
          {
            name: '冲单激励',
            id: 52,
            parentId: 5,
            path: '/performanceReward'
          }
        ]
      },
      {
        name: '客户管理',
        icon: 'customManagement',
        id: 6,
        path: '/customManagement'
      },
      {
        name: '设置',
        icon: 'setting',
        id: 8,
        childs: [
          {
            name: '修改密码',
            id: 81,
            parentId: 8,
            path: '/updatePwd'
          },
          {
            name: '打印设置',
            id: 82,
            parentId: 8,
            path: '/printSetting'
          }
        ]
      }
    ],
    orderInfo: {} as any,
    quickPrintOrderInfo: {} as any,
    copyOrderInfo: {} as any
  }),
  getters: {
    getMenusList: (state) => state.menuList,
    getUserLevel: (state) => state.userLevel,
    getOrderInfo: (state) => state.orderInfo,
    getQuickPrintOrderInfo: (state) => state.quickPrintOrderInfo,
    getCopyOrderInfo: (state) => state.copyOrderInfo
  },
  actions: {
    //登录
    login(params: any) {
      return new Promise((resolve, reject) => {
        ajaxAuthService
          .login(params)
          .then((res) => {
            if (res.code === 1) {
              this.userInfo = res.data
              this.token = res.data.token
              this.isLoggedIn = true
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    //退出登录
    logOut() {
      return new Promise((resolve, reject) => {
        ajaxAuthService
          .logOut()
          .then((res) => {
            if (res.code === 1) {
              this.token = ''
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    /** 存储订单信息 */
    setOrderInfo(value: any) {
      this.orderInfo = value
    },
    /** 存储快速打印订单信息 */
    setQuickPrintOrderInfo(value: any) {
      this.quickPrintOrderInfo = value
    },
    setCopyOrderInfo(value: any) {
      this.copyOrderInfo = value
    }
  },
  persist: {
    storage: localStorage
  }
})
